import { FlatTreeControl } from "@angular/cdk/tree";
import { Injectable, OnDestroy } from "@angular/core";
import { TreeDataSourceService } from "./tree-data-source.service";
import { TreeNode } from "./tree-node";
import * as _ from "lodash";
import { TreeListService } from "./tree-list.service";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TreeControlService
  extends FlatTreeControl<TreeNode>
  implements OnDestroy
{
  isProcessingSubject: Subject<boolean> = new Subject();
  get isProcessing$() {
    return this.isProcessingSubject.asObservable();
  }

  constructor(
    private storageList: TreeListService,
    private dataSource: TreeDataSourceService
  ) {
    super(
      (node) => (node ? node.level - 1 : null),
      (node) => node.expandable === true
    );
  }

  ngOnDestroy() {}
}
